/**
 * Session Flag Storage Service
 * Manages the Mariana active session flag in localStorage.
 */

const KEYS = {
  sessionActive: 'MarianaSessionActive',
} as const;

// --- marianaSessionActive ---

export function isSessionActive(): boolean {
  try {
    return localStorage.getItem(KEYS.sessionActive) === 'true';
  } catch {
    return false;
  }
}

export function setSessionActive(): void {
  try {
    localStorage.setItem(KEYS.sessionActive, 'true');
  } catch {
    // Silently fail — worst case the login event may fire again on reload
  }
}

export function clearSessionActive(): void {
  try {
    localStorage.removeItem(KEYS.sessionActive);
  } catch {
    // noop
  }
}
